import React, { Component } from "react";
import logo from "../../logo.svg";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import "./Header.css";
import Logo from "./Logo";
import InfoIcon from "./InfoIcon";
import locale from "../../utils/locale";

const styles = {
  root: {
    background: "#0A5DB8"
  }
};

class Header extends Component {
  render() {
    const { onHelpClick, classes, logo, hideIcons, hideInfoText } = this.props;
    return (
      <div className="app-header">
        <AppBar
          classes={{
            root: classes.root
          }}
        >
          <div className="grid-header-container">
            <div className="logo">
              <Logo source={logo}/>
            </div>
            <div className="info">
              <InfoIcon hideIcon={hideIcons} hideText={hideInfoText} onHelpClick={onHelpClick}/>
            </div>
          </div>
        </AppBar>
      </div>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  hideIcons: PropTypes.bool,
  onHelpClick: PropTypes.func,
  warning: PropTypes.bool
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js